import { z } from 'zod';
import { EPISODE_STATUSES, EPISODE_TYPES } from '../constants.js';
export const episodeChapterSchema = z
    .object({
    id: z.string(),
    startMs: z.number().int().min(0),
    endMs: z.number().int().min(0).optional(),
    title: z.string().min(1),
    summary: z.string().optional(),
})
    .refine((ch) => ch.endMs === undefined || ch.endMs > ch.startMs, {
    message: 'Chapter endMs must be greater than startMs',
});
export const createEpisodeSchema = z.object({
    title: z.string().min(1).max(200),
    description: z.string().optional(),
    episodeNumber: z.number().int().positive().optional(),
    episodeType: z.enum(EPISODE_TYPES).default('full'),
    seasonId: z.string().uuid().optional(),
});
export const updateEpisodeSchema = createEpisodeSchema.partial().extend({
    showNotes: z.string().optional(),
    status: z.enum(EPISODE_STATUSES).optional(),
    mediaFileId: z.string().uuid().nullable().optional(),
    scheduledAt: z.string().datetime().nullable().optional(),
    artworkUrl: z.string().nullable().optional(),
    chapters: z.array(episodeChapterSchema).nullable().optional(),
});
//# sourceMappingURL=episode.schemas.js.map